import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'searchPipe'
})
export class FilterPipe implements PipeTransform {
    transform(items: any, searchText: string, key: string): any[] {
        if (!items) {
            return [];
        }
        if (!searchText) {
            return items;
        }
        searchText = searchText.toLowerCase().trim();
        let r = items.filter(it => {
            if (it[key]) {
                return it[key].toLowerCase().includes(searchText);
            } else {
                // console.log('This invalid name');
            }
            // return it.item_name.toLowerCase().includes(searchText); Modify as per your array
        });
        return r;
    }
}



// WEBPACK FOOTER //
// ./public/app/_pipes/filter.pipe.ts